import React from 'react';
import { StyleSheet } from 'react-native';
import { Box, Button, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import ShareIcon from '../CustomSVGIcons/ShareIcon';

export interface IShareButton {
    url?: string;
    onShareButtonClicked?: () => void;
    title?: string;
    typographyStyle?: React.CSSProperties;
    iconStyle?: React.CSSProperties;
}
const EsShareButton: React.FC<IShareButton> = ({ onShareButtonClicked, iconStyle, typographyStyle }) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);
    return (
        <Button
            style={styles.detailsButton}
            onClick={onShareButtonClicked}
            aria-label="share button"
            sx={{
                textDecoration: 'none',
                px: 2.5,
                minWidth: 'unset',
                width: 'fit-content',
                height: 40,
                minHeight: 40,
                color: theme[themeStyle].pure_black,
                textTransform: 'none',
                cursor: 'pointer',
                border: `1px solid ${theme[themeStyle].darkGray}`,
                borderRadius: 100,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
                '&:hover': {
                    border: `1px solid ${theme[themeStyle].tag_white}`,
                },
            }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 22,
                    height: 22,
                    flexShrink: 0,
                    lineHeight: 0,
                    '& svg': { display: 'block', maxWidth: '100%', maxHeight: '100%' },
                }}>
                <ShareIcon style={{ width: 20, height: 20, ...iconStyle }} />
            </Box>
            <Typography
                style={{
                    fontFamily: FONT_ENUM.REGULAR_HEADER,
                    fontSize: 14,
                    fontWeight: 600,
                    lineHeight: 1,
                    color: theme[themeStyle].true_white,
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                    ...typographyStyle,
                }}>
                Share
            </Typography>
        </Button>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        detailsButton: {
            height: '40px',
            padding: '10px',
            borderRadius: 100,
            fontSize: 14,
            fontWeight: '600',
            fontFamily: FONT_ENUM.MAIN_BOLD,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
        },
    });

export { EsShareButton };
